import React from "react";
import { Link } from "react-router-dom";

const sections = [
  {
    title: "Information We Collect",
    body:
      "We collect the information you enter into the portal, including account details, visa booking details, applicant profile data, and operational records required to manage appointments and support services.",
  },
  {
    title: "How We Use Information",
    body:
      "We use this information to provide booking assistance, manage user access, communicate status updates, improve service reliability, and maintain internal audit and operational records.",
  },
  {
    title: "Sharing and Disclosure",
    body:
      "We do not sell personal information. Data may be shared only with authorized staff, service providers supporting portal operations, or where disclosure is required by law or necessary to complete the requested service.",
  },
  {
    title: "Data Security",
    body:
      "We apply reasonable technical and organizational measures to protect stored information against unauthorized access, misuse, alteration, or loss. Access is limited to authorized users and administrators.",
  },
  {
    title: "Your Choices",
    body:
      "You may request correction of inaccurate account or applicant data by contacting the portal administrator. Continued use of the website indicates acceptance of this policy and any future updates posted on this page.",
  },
];

export default function PrivacyPolicyPage() {
  return (
    <div
      className="min-vh-100 py-5 px-3"
      style={{ background: "linear-gradient(180deg, #f4f7fa 0%, #eaf1f8 100%)" }}
    >
      <div className="container" style={{ maxWidth: "900px" }}>
        <div className="card shadow-sm border-0" style={{ borderRadius: "20px" }}>
          <div className="card-body p-4 p-md-5">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
              <div>
                <div className="text-uppercase text-primary fw-semibold" style={{ letterSpacing: "0.08em", fontSize: "0.8rem" }}>
                  Visa Appointment Bot
                </div>
                <h1 className="fw-bold mb-2" style={{ fontSize: "2rem" }}>
                  Privacy Policy
                </h1>
                <p className="text-muted mb-0">
                  Effective date: July 28, 2026
                </p>
              </div>

              <div>
                <Link to="/" className="btn btn-outline-primary rounded-pill px-4">
                  Back to Login
                </Link>
              </div>
            </div>

            <div className="alert alert-light border mb-4" role="alert">
              This policy explains how visaappointmentbot.com collects, uses, and protects information submitted through this website and related booking management tools.
            </div>

            <div className="d-grid gap-4">
              {sections.map((section) => (
                <section key={section.title}>
                  <h2 className="h5 fw-bold mb-2">{section.title}</h2>
                  <p className="text-muted mb-0" style={{ lineHeight: 1.8 }}>
                    {section.body}
                  </p>
                </section>
              ))}
            </div>

            <hr className="my-4" />

            <section>
              <h2 className="h5 fw-bold mb-2">Contact</h2>
              <p className="text-muted mb-0" style={{ lineHeight: 1.8 }}>
                For privacy-related questions or account data correction requests, contact the website administrator through the official support channel used for your booking service.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}